import { Component } from '@angular/core';
import { Market } from '../../../shared/models/dataref.model';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-market-dialog',
  templateUrl: 'select-market-dialog.component.html',
  standalone: false,
})
export class SelectMarketDialogComponent {
  marketSelected: undefined | Market = undefined;

  constructor(public dialogRef: MatDialogRef<SelectMarketDialogComponent>) {}

  cancel(): void {
    this.dialogRef.close();
  }

  submitSelection(): void {
    this.dialogRef.close(this.marketSelected);
  }

  add($event: Market): void {
    this.marketSelected = $event;
  }
}
